<!-- //
上传文件对话框形态
@auth xuyd
@date 2022-09-10
//-->
<template>
  <el-dialog
      title="脚本"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      top="10vh"
      width="900px">
    <MonacoEditor v-model="form.value" :options="form" style="height: 400px;" />
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ cancelButtonText }}</el-button>
      <el-button size="small" v-if="visibleConfirm" type="primary" @click="handleOk">{{ confirmButtonText }}</el-button>
    </span>
  </el-dialog>
</template>
<script>

import MonacoEditor from './monacoEditor.vue'

export default {
  name: 'MonacoEditorDialog',
  components: {MonacoEditor},
  data() {
    return {
      visible: false,
      editMode: true, // true可以编辑，false不可编辑
      form: {
        value: null,
      },
      opts: {}
    }
  },
  computed: {
    cancelButtonText() {
      return this.opts.cancelButtonText;
    },
    confirmButtonText() {
      return this.opts.confirmButtonText;
    },
    visibleConfirm() {
      return this.opts.visibleConfirm;
    },
  },
  methods: {
    /**
     * 显示对话框
     * @param data
     * @param onOk
     */
    showModal({data, onOk}) {
      this.form = {...data};
      this.editMode =  !this.form.readOnly; // 是否是编辑mode
      let that = this;
      this.dialogShow({
        visibleConfirm: this.editMode,
        confirmButtonText: data?.confirmButtonText || '确定',
        cancelButtonText: data?.cancelButtonText || '取消',
        onOk(data) {
          let promise = onOk && onOk(data);
          if(promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        }
      })
    },
    dialogShow(opts) {
      this.opts = opts
      this.visible = true;
    },

    hideModal() {
      this.visible = false;
      this.form = {value: null, options: {}};
    },
    handleOk() {
      // console.log("-------handleOk-------->", this.form.fileList)
      this.opts.onOk(this.form);
    },
  },
}
</script>

<style lang="less" scoped>

</style>


